'use client';

import { PropsWithChildren, useEffect } from 'react';

export default function ThemeProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    const theme = window.localStorage.getItem('color-theme');
    const className = 'dark';
    const bodyClass = window.document.body.classList;

    if (theme === JSON.stringify('dark')) {
      bodyClass.add(className);
      return;
    }

    bodyClass.remove(className);
  }, []);

  return <>{children}</>;
}
